import axios from './AxiosService';

export default class LandingPageService {
  async send_correo(params) {
    return await axios.post('/contacto/send', params).then(response => response.data);
  }
}